import { atom } from 'nanostores';

export const $sidebarCollapsed = atom<boolean>(false);
export const $currentPage = atom<string>('/');
export const $isLoading = atom<boolean>(false);
